import AlertPopup from "./alert-popup"
window.AlertPopup = AlertPopup

// assume "content missing" is a page visit
document.addEventListener('turbo:frame-missing', (e) => {
  e.preventDefault()

  const targetLocation = e.detail.response.url
  e.detail.visit(targetLocation)
})

// actual history navigation for "previous" button
window.clientHistory = {
  stack: [],
  addEntry(){
    const { pathname, href } = window.location
    const lastLocation = this.stack[this.stack.length-1]

    if(!lastLocation || lastLocation.pathname !== pathname){
      this.stack.push({ pathname, href })

      if(this.stack.length > 50) this.stack.shift()
    }
  },
  returnToLast(){
    let lastLocation = this.stack[this.stack.length-1]

    try{
      while(lastLocation.pathname == window.location.pathname){
        this.stack.pop()
        lastLocation = this.stack[this.stack.length-1]
      }

      Turbo.visit(lastLocation.href)
    }catch(err){ history.back() }
  }
}
document.addEventListener('turbo:load', () => {
  clientHistory.addEntry()
})

console.log('app is ready')